import { render, staticRenderFns } from "./gongshui.vue?vue&type=template&id=1b512b8e&scoped=true&"
import script from "./gongshui.vue?vue&type=script&lang=js&"
export * from "./gongshui.vue?vue&type=script&lang=js&"
import style0 from "./gongshui.vue?vue&type=style&index=0&id=1b512b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b512b8e",
  null
  
)

export default component.exports